export default __webpack_public_path__ + "static/media/IconDesc_Cnr_QuarterPipe_04.256.cc613f6e.png";